
import { defineComponent, PropType, computed, ref, toRef } from 'vue';
import { ITimelineEntry, ITimeline } from '@/models/timeline.model';
import useConverter from '@/composables/general/useConverter';
import useStringManip from '@/composables/general/useStringManip';
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import TimelineEntryContent from '@/components/timeline/displayElements/TimelineEntryContent.vue';

export default defineComponent({
  name: 'TimelineEntry',
  components: {
    OverlayPanel,
    Dialog,
    TimelineEntryContent,
  },
  props: {
    entry: {
      type: Object as PropType<ITimelineEntry>,
      required: true,
    },
    timeline: {
      type: Object as PropType<ITimeline>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    fullScreen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    const timeline = toRef(props, 'timeline');
    const info = ref();
    const showInfo = ref(false);
    const { truncate } = useStringManip();
    const { formattedDate } = useConverter();

    const timePeriod = computed(() => {
      if (!timeline.value.show_month) {
        if (props.entry.end && props.entry.start) {
          return `${formattedDate(props.entry.start, true)} - ${formattedDate(props.entry.end, true)}`;
        } else if (props.entry.start && !props.entry.end) {
          return formattedDate(props.entry.start, true);
        } else if (props.entry.description) {
          return truncate(props.entry.description, 25) + '...';
        } else {
          return undefined;
        }
      } else {
        if (props.entry.end && props.entry.start) {
          if (formattedDate(props.entry.end, false, true) == formattedDate(props.entry.start, false, true)) {
            return formattedDate(props.entry.start, false, true);
          }
          return `${formattedDate(props.entry.start, false, true)} - ${formattedDate(props.entry.end, false, true)}`;
        } else if (props.entry.start && !props.entry.end) {
          return formattedDate(props.entry.start, false, true);
        } else if (props.entry.description) {
          return truncate(props.entry.description, 25) + '...';
        } else {
          return undefined;
        }
      }
    });
    const showOverlay = computed(() => {
      return props.entry.description || props.entry.linked_page || props.entry.uri || props.entry.linked_project
        ? true
        : false;
    });
    const disableHover = computed(() => {
      return !showOverlay.value ? 'no-hover' : '';
    });
    const uriDisplay = computed(() => {
      if (props.entry.uri_title) {
        return props.entry.uri_title;
      } else if (props.entry.uri) {
        return props.entry;
      } else {
        return false;
      }
    });
    const descriptionDisplay = computed(() => {
      return props.entry.description ? props.entry.description : false;
    });
    const linkedPageDisplay = computed(() => {
      return props.entry.linked_page?.links.external_show_uri ? props.entry.linked_page.links.external_show_uri : false;
    });
    const linkedProjectDisplay = computed(() => {
      return props.entry.linked_project ? props.entry.linked_project : false;
    });
    function displayInfo(event: any) {
      if (showOverlay.value) {
        if (props.fullScreen) {
          showInfo.value = !showInfo.value;
        } else {
          info.value.toggle(event);
        }
      }
    }
    return {
      info,
      timePeriod,
      showInfo,
      showOverlay,
      disableHover,
      uriDisplay,
      descriptionDisplay,
      linkedProjectDisplay,
      linkedPageDisplay,
      displayInfo,
    };
  },
});
